export default {
  bind: function (el, binding, vNode) {
    const vm = vNode.context
    el.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      vm.$store.dispatch('ui/closeAll')
    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/DirectiveUiClose.js